const carouselTypes = {
  default: {
    infinite: false,
    useTransform: false,
    slidesToShow: 7,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          arrows: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  },
  marketplaceCarouselRedesign: {
    props: {
      infinite: false,
      useTransform: false,
      slidesToShow: 6,
      slidesToScroll: 2,
      dots: false,
      arrows: true,
      variableWidth: true,
      responsive: [
        {
          breakpoint: 800,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            arrows: false,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    },
  },
};

export const getSlickPropsByPage = function (pageType) {
  if (pageType && carouselTypes[pageType]) {
    return carouselTypes[pageType]['props'];
  }
  return carouselTypes.default;
};

export const getClassByPage = function (pageType) {
  if (pageType && carouselTypes[pageType]) {
    return carouselTypes[pageType]['class'];
  }
  return '';
};
